import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "table-header p-d-flex p-ai-center" }
const _hoisted_2 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_component_DataTable, {
    value: _ctx.rows,
    class: "p-datatable-sm kn-table",
    selection: _ctx.selectedRow,
    "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedRow = $event)),
    selectionMode: _ctx.multivalue ? false : 'single',
    filters: _ctx.filters,
    "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
    globalFilterFields: _ctx.globalFilterFields,
    paginator: _ctx.rows.length > 20,
    rows: 20,
    responsiveLayout: "stack",
    breakpoint: "600px",
    scrollable: true,
    scrollHeight: _ctx.knParameterPopupDialogDescriptor.dialog.scrollHeight,
    onRowSelect: _ctx.setSelectedRow,
    onRowUnselect: _ctx.setSelectedRow,
    onRowSelectAll: _ctx.setSelectedRow,
    onRowUnselectAll: _ctx.setSelectedRow
  }, {
    empty: _withCtx(() => [
      _createVNode(_component_Message, {
        class: "p-m-2",
        severity: "info",
        closable: false,
        style: _ctx.knParameterPopupDialogDescriptor.styles.message
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_InputText, {
            class: "kn-material-input",
            modelValue: _ctx.filters['global'].value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
            type: "text",
            placeholder: _ctx.$t('common.search')
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.multivalue)
        ? (_openBlock(), _createBlock(_component_Column, {
            key: 0,
            selectionMode: "multiple",
            style: _ctx.knParameterPopupDialogDescriptor.styles.checkboxColumn
          }, null, 8, ["style"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
        return (_openBlock(), _createBlock(_component_Column, {
          class: "kn-truncated",
          field: col.field,
          header: col.header,
          key: col.field,
          sortable: true
        }, null, 8, ["field", "header"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "selection", "selectionMode", "filters", "globalFilterFields", "paginator", "scrollHeight", "onRowSelect", "onRowUnselect", "onRowSelectAll", "onRowUnselectAll"]))
}